import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

function RouteTableView({
    routes,
    user
}) {

    function getRouteCategoryBadge(category) {
        switch (category) {
            case "Road":
                return "/resources/images/road75.png";
            case "OffRoad":
                return "/resources/images/mtb75.png";
            case "Gravel":
                return "/resources/images/gravel75.png";
            default:
                return "/resources/images/road75.png"
        }
    }

    return (
        <table className="table route-results-list">
            <thead className="thead-light">
                <tr>
                    <th width="20px"scope="col"></th>
                    <th scope="col">Name</th>
                    <th scope="col">Location</th>
                    <th scope="col">Distance</th>
                    <th scope="col">Elevation</th>
                </tr>
            </thead>
            <tbody>
            {
                routes.results.map((route, index) => {
                    return (
                        <tr key={route.routeId}>
                            <td scope="row"><img src={getRouteCategoryBadge(route.category)} className="route-badge" alt={route.category} /></td>
                            <td><Link to={"/routes/" + route.routeId}>{route.name}</Link></td>
                            <td>{route.locationInformation.subRegion}</td>
                            <td>{user.preferredMeasurementUnits == 'Statute' ? `${Math.round((route.totalDistanceKm * 0.621371192) * Math.pow(10, 2)) / Math.pow(10, 2)}mi` : `${Math.round(route.totalDistanceKm * Math.pow(10, 2)) / Math.pow(10, 2)}km`}</td>
                            <td>{user.preferredMeasurementUnits == 'Statute' ? `${Math.round((route.totalElevation * 3.2808399) * Math.pow(10, 2)) / Math.pow(10, 2)}ft` : `${Math.round(route.totalElevation * Math.pow(10, 2)) / Math.pow(10, 2)}m`}</td>
                        </tr>
                    );
                })}
            </tbody>
        </table>


    );
}
RouteTableView.propTypes = {
    routes: PropTypes.object.isRequired
};

export default RouteTableView;


//user.preferredMeasurementUnits == 'Statute' ? 'Elevation(ft)' : 'Elevation(m)',



// WEBPACK FOOTER //
// ./src/components/routes/RouteTableView.js